import { Injectable } from '@angular/core';

declare let gtag: (...args: unknown[]) => void;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsService {

  public emitEventWithParams(eventName: string, params: Record<string, string>): void {
    gtag('event', eventName, params);
  }

  public emitRelatedEntryClick(linkType: string, isComplex: boolean, assemblyType: string): void {
    const entryType = isComplex ? 'multimer' : 'monomer';
    const asm = (assemblyType || '').toLowerCase();
    const mappedAssemblyType = (asm === 'homo' || asm === 'hetero') ? asm : 'mono';
    this.emitEventWithParams('related_entries_clickthough', {
      entry_type: entryType,
      assembly_type: mappedAssemblyType,
      link_type: linkType,
    });
  }

  public emitPortalCardClick(categorySlug: string): void {
    // Mirrors BrowseDataCarouselComponent's own mobile breakpoint (its MOBILE_QUERY) so
    // device_type reflects the same mobile/desktop split as the carousel's layout. Calling
    // window directly is safe here: this only ever runs from a click handler, which never
    // executes during SSR.
    const deviceType = window.matchMedia('(max-width: 39.9375em)').matches ? 'mobile' : 'desktop';
    this.emitEventWithParams('portal_card_click', {
      card_type: categorySlug,
      device_type: deviceType,
    });
  }

  public eventEmitter(
    eventName: string,
    eventCategory: string,
    eventAction: string,
    eventLabel: string | null = null,
    eventValue: string | null = null): void {
     gtag('event', eventName, {
      eventCategory,
      eventLabel,
      eventAction,
      eventValue
    });
  }
}
